import React from "react";
import { PORT_COLOR_MAP, PortColor } from "../../utils/appConstants";
import { wrapInTooltip } from "../../utils/methods";

interface LinkImageInterface {
  leftColor: PortColor;
  leftPlug: PortColor;
  rightColor: PortColor;
  rightPlug: PortColor;
  linkColor: PortColor;
  size?: number;
}

// const getLinkTooltip = (props: LinkImageInterface) => {
//   if(props.linkColor === PortColor.Red) {
//     return "This link is sold in the marketplace."
//   } else if(props.linkColor === PortColor.Yellow) {
//     return "This link is listed in the marketplace. You may not interact with the link ."
//   } else 
// }

const LinkImage: React.FC<LinkImageInterface> = (props) => {
  const linkColor = PORT_COLOR_MAP[props.linkColor];
  const leftColor = PORT_COLOR_MAP[props.leftColor];
  const leftPlug = PORT_COLOR_MAP[props.leftPlug];
  const rightColor = PORT_COLOR_MAP[props.rightColor];
  const rightPlug = PORT_COLOR_MAP[props.rightPlug];
  const size = props.size || "100%";
  const maxSize = "300px";

  const link = (
    <div style={{ width: size, maxWidth: maxSize, aspectRatio: "207/32" }}>
      <svg width="100%" viewBox="0 0 207 32">
        <rect fill={leftColor} height="32" stroke={leftColor} width="32" x="0" y="0" />
        <rect fill="#ffffff" height="16" stroke={leftColor} strokeWidth="0" width="24" x="4" y="4.91" />
        <rect fill="#ffffff" height="11" stroke={leftColor} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="18" x="7" y="13" />
        <rect fill="#ffffff" height="22" stroke={leftColor} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="12" x="10" y="5" />
        <rect fill={leftPlug} height="12" stroke={leftColor} strokeWidth="0" width="20" x="6" y="7" />
        <rect fill={leftPlug} height="12" stroke={leftColor} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="14" x="9" y="9.98" />
        <rect fill={leftPlug} height="11" stroke={leftColor} strokeWidth="0" width="8" x="12" y="14" />
        <line x1="32" x2="175" y1="16" y2="16" fill={linkColor} stroke={linkColor} strokeWidth="10" />
        <rect fill={rightColor} height="32" stroke={rightColor} width="32" x="175" y="0" />
        <rect fill="#ffffff" height="16" stroke={rightColor} strokeWidth="0" width="24" x="179" y="4.91" />
        <rect fill="#ffffff" height="11" stroke={rightColor} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="18" x="182" y="13" />
        <rect fill="#ffffff" height="22" stroke={rightColor} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="12" x="185" y="5" />
        <rect fill={rightPlug} height="12" stroke={rightColor} strokeWidth="0" width="20" x="181" y="7" />
        <rect fill={rightPlug} height="12" stroke={rightColor} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="14" x="184" y="9.98" />
        <rect fill={rightPlug} height="11" stroke={rightColor} strokeWidth="0" width="8" x="187" y="14" />
      </svg>
    </div>
  );

  return link;
};

export default LinkImage;
